import React from 'react';
import { SignInWrapper } from './SignInWrapper';
import { SignInButtons } from './SignInButtons';

export const SignInEntry = () => (
    <SignInWrapper>
        <SignInButtons />
    </SignInWrapper>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/SignIn/SignInEntry.js